/* eslint-disable no-undef */
import axios from 'axios'

export type UserListToManager = {
    users: Array<UserData>,
    pageNum: number,
    totalPage: number,
    from: number,
    to: number,
    total: number,
    search: string
}

export type UserData = {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    modified: string,
    isActive: boolean,
    emailVerified: boolean,
    residentKey: string,
    streetAndUnitNumber: string,
    communities: Array<AddressAndProperty>
}

export type AddressAndProperty = {
    address: string,
    community: string
}

export const getUserListToManageAsync = async(search: string = "", page: number = 0) => {
    let parametersStr = search != ""? page > 0 ? `?search=${search}&page=${page}` : `?search=${search}` : page > 0 ? `?page=${page}`: ""

    return await axios({
		url: `/User/GetUserListToManage${parametersStr}`,
		method: "GET",
	});

    // return {
    //     data: {
    //         users: [{
    //             id: 1,
    //             firstName: "test",
    //             lastName: "test",
    //             email: "test",
    //             modified: "test",
    //             isActive: true,
    //             emailVerified: true,
    //             residentKey: "test",
    //             streetAndUnitNumber: "test",
    //             communities: [
    //                 {
    //                     address: "string",
    //                     community: "string"
    //                 }
    //             ]
    //         }],
    //         pageNum: 1,
    //         totalPage: 1,
    //         from: 0,
    //         to: 1,
    //         total: 1,
    //         search: ""
    //     }
    // }
}
